import { Typography } from '@/components/Typography/Typography';
import { COLORS } from '@/styles/colors';
import { CookiesBannerButtonGroup, CookiesBannerWrapper, ManagePreferencesButton, PrivacyPolicyLink } from './styles';
import { Button } from '@/components/Button/Button';
import { envConfig } from '@/config/envConfig';
import { useState } from 'react';
import { CookiesManagePreferencesModal } from './CookiesManagePreferencesModal/CookiesManagePreferencesModal';
import { CookiesPreferencesType, useCookiesPreferences } from './cookiesContext';
import { useCheckCookiesExpiration } from '@/bundle/shared/hooks/useCheckCookiesExpiration';

export const CookiesBanner = () => {
  const { hasPreferences, acceptAll, preferences, save, clear } = useCookiesPreferences();
  const [isBannerOpen, setIsBannerOpen] = useState(() => {
    return !hasPreferences;
  });
  const [isModalOpen, setIsModalOpen] = useState(false);

  const manageCookiesPreferences = () => {
    setIsModalOpen(true);
    setIsBannerOpen(false);
  };

  const acceptAllCookies = () => {
    acceptAll();
    setIsBannerOpen(false);
  };

  const saveCookiesPreferences = (newPreference: CookiesPreferencesType) => {
    save(newPreference);
    setIsModalOpen(false);
    setIsBannerOpen(false);
  };

  const closeCookiePreferencesModal = () => {
    setIsModalOpen(false);
    setIsBannerOpen(true);
  };

  useCheckCookiesExpiration(() => {
    clear();
    setIsBannerOpen(true);
  });

  return (
    <>
      {isBannerOpen && (
        <CookiesBannerWrapper>
          <Typography color={COLORS.grey[200]} variant='bodySmall' marginBottom='8px'>
            We use cookies to give you the best possible experience, including third-party services that use cookies.
            Some are essential for this site to function; others help us understand how you use the site, so we can
            improve it. We may also use cookies for targeting purposes.
          </Typography>
          <Typography color={COLORS.grey[200]} fontWeight='semibold' variant='bodySmall' marginBottom='8px'>
            We do not sell any information that we collect as part of your use of our website.
          </Typography>
          <Typography color={COLORS.grey[200]} variant='bodySmall' marginBottom='24px'>
            Please see our{' '}
            <PrivacyPolicyLink href={envConfig.PRIVACY_POLICY_URL} target='_blank'>
              {' '}
              Privacy Policy
            </PrivacyPolicyLink>{' '}
            and{' '}
            <PrivacyPolicyLink href={envConfig.COOKIES_POLICY_URL} target='_blank'>
              {' '}
              Cookie Policy
            </PrivacyPolicyLink>{' '}
            for more information.
          </Typography>

          <CookiesBannerButtonGroup>
            <ManagePreferencesButton onClick={manageCookiesPreferences}>Manage my preferences</ManagePreferencesButton>
            <Button size='medium' onClick={acceptAllCookies}>
              Accept all cookies
            </Button>
          </CookiesBannerButtonGroup>
        </CookiesBannerWrapper>
      )}

      <CookiesManagePreferencesModal
        preferences={preferences}
        isOpen={isModalOpen}
        onSave={saveCookiesPreferences}
        onClose={closeCookiePreferencesModal}
      />
    </>
  );
};
